import React, { useEffect, useState } from "react";
import axios from "axios";

import "./css/dashboard.css";

import {
  Row,
  Col,
  Layout,
  Card,
  Divider,
  Space,
  Select,
  Button,
  Form,
  Modal,
  InputNumber,
  Radio
} from "antd";

import moment from "moment";

import { SaveOutlined, ClearOutlined } from "@ant-design/icons";

import swal from "sweetalert";

import Hightchart2 from "./Highchart2";
import Piechart2 from "./Piechart2";
import Mixchart from "./Mixchart";

const { Option } = Select;

const Dashboard_i = prop => {
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  let xURL = "";
  let xlocation = window.location.hostname;

  // if (xlocation === "localhost") {
  //   xURL = "http://localhost:3002/api/";
  // } else {
  //   xURL = "https://research.rihes.cmu.ac.th/api/";
  // }

  xURL = "https://research.rihes.cmu.ac.th/api/";

  let YearNow = moment().format("YYYY");

  const [YearValue, _YearValue] = useState(YearNow);
  const [xYeardh, _xYeardh] = useState([]);
  const [xYeardh2, _xYeardh2] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);

  const [Kr6_old, _Kr6_old] = useState("");
  const [Kr6_old_2, _Kr6_old_2] = useState("");
  const [Kr7_old, _Kr7_old] = useState("");
  const [Kr8_old, _Kr8_old] = useState("");
  const [Stu_old, _Stu_old] = useState("");
  const [PubStu_old, _PubStu_old] = useState("");
  const [GStu_old, _GStu_old] = useState("");

  const [Num_Color1, _Num_Color1] = useState("red");
  const [Num_Color2, _Num_Color2] = useState("red");
  const [Num_Color3, _Num_Color3] = useState("red");
  const [Num_Color4, _Num_Color4] = useState("red");
  const [Num_Color5, _Num_Color5] = useState("red");
  const [Num_Color6, _Num_Color6] = useState("red");

  const [data_Kr6, _data_Kr6] = useState();
  const [data_Kr6_2, _data_Kr6_2] = useState();
  const [data_Kr7, _data_Kr7] = useState();
  const [data_Kr8, _data_Kr8] = useState();
  const [data_NoSTU, _data_NoSTU] = useState();
  const [data_PubSTU, _data_PubSTU] = useState();
  const [data_GradSTU, _data_GradSTU] = useState();

  const [goal_Kr6, _goal_Kr6] = useState();
  const [goal_Kr6_2, _goal_Kr6_2] = useState();
  const [goal_Kr7, _goal_Kr7] = useState();
  const [goal_Kr8, _goal_Kr8] = useState();
  const [goal_NoSTU, _goal_NoSTU] = useState();
  const [goal_PubSTU, _goal_PubSTU] = useState();
  const [goal_GradSTU, _goal_GradSTU] = useState();

  const [dataSum_Kr6, _dataSum_Kr6] = useState();
  const [dataSum_Kr7, _dataSum_Kr7] = useState();
  const [dataSum_Kr8, _dataSum_Kr8] = useState();
  // const [dataSum_NoSTU, _dataSum_NoSTU] = useState();
  const [dataSum_PubSTU, _dataSum_PubSTU] = useState();
  // const [dataSum_GradSTU, _dataSum_GradSTU] = useState();

  const [dataHigh4, _dataHigh4] = useState([]);

  const [dataPie1, _dataPie1] = useState([]);

  let xFontsum = "17px";

  useEffect(() => {
    axios
      .get(xURL + "year_papers")
      .then(result => {
        //console.log(result.data);

        _xYeardh(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });

    axios
      .get(xURL + "year_papers2")
      .then(result => {
        //console.log(result.data);

        _xYeardh2(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });

    Find_scopus("I1", YearValue);
    Find_scopus("I2", YearValue);
    Find_scopus("I3_1", YearValue);
    Find_scopus("I3", YearValue);
    Find_scopus("I4", YearValue);
    Find_scopus("I5", YearValue);
    Find_scopus("I6", YearValue);

    Find_highData("I3", YearValue);

    Find_PieData("I1", YearValue);
  }, []);

  const handleChange = value => {
    // console.log(`selected ${value}`);
    Find_scopus("I1", value);
    Find_scopus("I2", value);
    Find_scopus("I3_1", value);
    Find_scopus("I3", value);
    Find_scopus("I4", value);
    Find_scopus("I5", value);
    Find_scopus("I6", value);

    Find_highData("I3", value);

    Find_PieData("I1", value);

    _YearValue(value);
  };

  const handleChange2 = value => {
    // console.log(`selected ${value}`);
    Find_scopus2("I5", value);
  };

  const bClearclick = () => {
    form1.resetFields();

    findGoal();
  };

  const bSaveclick = () => {
    const f = form1.getFieldsValue();

    if (!f.ipKr6) {
      swal(
        "บันทึกไม่ได้!",
        "ยังไม่ได้กรอก [KR5] ร้อยละผลงานตีพิมพ์ของนักศึกษาที่อยู่ใน Q1 ของฐานข้อมูล Scopus (Goal)!",
        "warning"
      );
    } else if (!f.ipKr6_1) {
      swal(
        "บันทึกไม่ได้!",
        "ยังไม่ได้กรอก [KR6] ร้อยละของนักศึกษาที่เรียนจบตามกำหนดเวลา (Goal)!",
        "warning"
      );
    } else if (!f.ipKr8) {
      swal(
        "บันทึกไม่ได้!",
        "ยังไม่ได้กรอก [KR7] การเปิดสอนหลักสูตรใหม่ (จำนวนหลักสูตร) (Goal)!",
        "warning"
      );
    } else {
      swal({
        title: "Confirm Edit Goal",
        text: "Year " + YearValue,
        icon: "warning",
        buttons: ["Cancle", "Ok"]
      }).then(willOk => {
        if (willOk) {
          updatedata();
        }
      });
    }
  };

  const updatedata = () => {
    const f = form1.getFieldsValue();

    let xdata = [
      { name: "KR6 %Pub in Q1(STU)", goal: f.ipKr6, old: Kr6_old },
      { name: "KR6 %Graduate (STU)", goal: f.ipKr6_1, old: Kr6_old_2 },
      { name: "KR8 New Program", goal: f.ipKr8, old: Kr8_old }
    ];

    // console.log(emplydata);

    xdata.forEach((i, idx) => {
      if (!i.old) {
        axios
          .post(xURL + "insert_goal", {
            year: YearValue,
            name: i.name,
            goal: i.goal
          })
          .then(result => {
            swal("Save Complete!", "", "success");
            setModalOpen(false);

            // console.log(result.data);

            Find_scopus("I1", YearValue);
            Find_scopus("I2", YearValue);
            Find_scopus("I3_1", YearValue);
            Find_scopus("I3", YearValue);
            Find_scopus("I4", YearValue);
            Find_scopus("I5", YearValue);
            Find_scopus("I6", YearValue);

            Find_highData("I3", YearValue);

            Find_PieData("I1", YearValue);
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      } else {
        axios
          .post(xURL + "update_goal", {
            year: YearValue,
            name: i.name,
            goal: i.goal
          })
          .then(result => {
            swal("Save Complete!", "", "success");
            setModalOpen(false);

            // console.log(result.data);

            Find_scopus("I1", YearValue);
            Find_scopus("I2", YearValue);
            Find_scopus("I3_1", YearValue);
            Find_scopus("I3", YearValue);
            Find_scopus("I4", YearValue);
            Find_scopus("I5", YearValue);
            Find_scopus("I6", YearValue);

            Find_highData("I3", YearValue);

            Find_PieData("I1", YearValue);
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      }
    });
  };

  const findGoal = () => {
    _Kr6_old("");
    _Kr7_old("");
    _Kr8_old("");
    _Stu_old("");
    _PubStu_old("");
    _GStu_old("");

    axios
      .post(xURL + "db_findGoal", { year: YearValue })
      .then(result => {
        // console.log("data", result.data);

        result.data.forEach((i, idx) => {
          if (i.topic == "KR6 %Pub in Q1(STU)") {
            form1.setFieldsValue({
              ipKr6: i.goal
            });

            _Kr6_old(i.goal);
          } else if (i.topic == "KR6 %Graduate (STU)") {
            form1.setFieldsValue({
              ipKr6_1: i.goal
            });

            _Kr6_old_2(i.goal);
          } else if (i.topic == "KR7 %On- time Graduate") {
            // else if (i.topic == "KR7 %Int. STU") {
            //   form1.setFieldsValue({
            //     ipKr7: i.goal
            //   });

            //   _Kr7_old(i.goal);
            // }
            form1.setFieldsValue({
              ipKr7: i.goal
            });

            _Kr7_old(i.goal);
          } else if (i.topic == "KR8 New Program") {
            form1.setFieldsValue({
              ipKr8: i.goal
            });

            _Kr8_old(i.goal);
          } else if (i.topic == "No. of STU") {
            form1.setFieldsValue({
              ipStu: i.goal
            });

            _Stu_old(i.goal);
          } else if (i.topic == "Pub in SCOPUS(STU)") {
            form1.setFieldsValue({
              ipPubStu: i.goal
            });

            _PubStu_old(i.goal);
          } else if (i.topic == "Total Graduate STU") {
            form1.setFieldsValue({
              ipGStu: i.goal
            });

            _GStu_old(i.goal);
          }
        });
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_scopus = (order, YearValue) => {
    axios
      .post(xURL + "db_tabbox", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        if (result.data[0]) {
          if (order == "I1") {
            _data_Kr6(result.data[0].pub_data);
            _goal_Kr6(result.data[0].goal);
            _dataSum_Kr6(
              result.data[0].countkr6 + "/" + result.data[0].countkr6a
            );

            const percentage =
              parseFloat(result.data[0].pub_data) /
              parseFloat(result.data[0].goal) *
              100;

            if (percentage < 50) {
              _Num_Color1("red");
            } else if (percentage < 80) {
              _Num_Color1("#FFA500"); // เหลือง
            } else {
              _Num_Color1("green");
            }
          } else if (order == "I3_1") {
            _data_Kr6_2(0);
            _goal_Kr6_2(result.data[0].goal);

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color2("green");
            } else {
              _Num_Color2("red");
            }
          } else if (order == "I3") {
            _data_Kr8(0);
            _dataSum_Kr8(result.data[0].pub_data);
            _goal_Kr8(result.data[0].goal);

            const percentage =
              parseFloat(result.data[0].pub_data) /
              parseFloat(result.data[0].goal) *
              100;

            if (percentage < 50) {
              _Num_Color3("red");
            } else if (percentage < 80) {
              _Num_Color3("#FFA500"); // เหลือง
            } else {
              _Num_Color3("green");
            }
          } else if (order == "I4") {
            _data_NoSTU(result.data[0].pub_data);
            _goal_NoSTU(result.data[0].goal);
            // _dataSum_NoSTU(result.data[0].countNostu);

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color4("green");
            } else {
              _Num_Color4("red");
            }
          } else if (order == "I5") {
            _data_PubSTU(result.data[0].pub_data);
            _goal_PubSTU(result.data[0].goal);
            _dataSum_PubSTU(result.data[0].countPubStu);

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color5("green");
            } else {
              _Num_Color5("red");
            }
          } else if (order == "I6") {
            _data_GradSTU(result.data[0].pub_data);
            _goal_GradSTU(result.data[0].goal);
            // _dataSum_GradSTU(result.data[0].countGradStu);

            if (
              parseFloat(result.data[0].pub_data) >=
              parseFloat(result.data[0].goal)
            ) {
              _Num_Color6("green");
            } else {
              _Num_Color6("red");
            }
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_scopus2 = (order, YearValue) => {
    axios
      .post(xURL + "db_tabbox2", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        if (result.data[0]) {
          if (order == "I5") {
            _data_Kr6(result.data[0].pub_data);
            _goal_Kr6(result.data[0].goal);
            _dataSum_Kr6(
              result.data[0].countkr6 + "/" + result.data[0].countkr6a
            );

            const percentage =
              parseFloat(result.data[0].pub_data) /
              parseFloat(result.data[0].goal) *
              100;

            if (percentage < 50) {
              _Num_Color1("red");
            } else if (percentage < 80) {
              _Num_Color1("#FFA500"); // เหลือง
            } else {
              _Num_Color1("green");
            }
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_highData = (order, YearValue) => {
    axios
      .post(xURL + "db_Highdata2", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        let Tb1 = [];

        let xsum = 0;

        let xgoal12 = 0,
          xgoal11 = 0,
          xgoal10 = 0,
          xgoal9 = 0,
          xgoal8 = 0,
          xgoal7 = 0,
          xgoal6 = 0,
          xgoal5 = 0,
          xgoal4 = 0,
          xgoal3 = 0,
          xgoal2 = 0,
          xgoal1 = 0;

        xgoal12 = parseFloat(result.data[0].goal).toFixed(1);
        xgoal11 = parseFloat(xgoal12 - xgoal12 / 12).toFixed(1);
        xgoal10 = parseFloat(xgoal11 - xgoal12 / 12).toFixed(1);
        xgoal9 = parseFloat(xgoal10 - xgoal12 / 12).toFixed(1);
        xgoal8 = parseFloat(xgoal9 - xgoal12 / 12).toFixed(1);
        xgoal7 = parseFloat(xgoal8 - xgoal12 / 12).toFixed(1);
        xgoal6 = parseFloat(xgoal7 - xgoal12 / 12).toFixed(1);
        xgoal5 = parseFloat(xgoal6 - xgoal12 / 12).toFixed(1);
        xgoal4 = parseFloat(xgoal5 - xgoal12 / 12).toFixed(1);
        xgoal3 = parseFloat(xgoal4 - xgoal12 / 12).toFixed(1);
        xgoal2 = parseFloat(xgoal3 - xgoal12 / 12).toFixed(1);
        xgoal1 = parseFloat(xgoal2 - xgoal12 / 12).toFixed(1);

        if (result.data[0]) {
          if (YearValue.toString() == moment().format("YYYY")) {
            // console.log(parseInt(moment().format("MM")));
            let currentMonth = parseInt(moment().format("MM")); // เดือนปัจจุบัน (1-12)
            xsum = 0;

            for (let i = 1; i <= 12; i++) {
              let monthKey = `m${i}`;
              let goalKey = `xgoal${i}`; // ตัวแปร goal สำหรับแต่ละเดือน

              if (i <= currentMonth) {
                xsum += result.data[0][monthKey];

                Tb1.push({
                  name: i.toString(),
                  data_in_Month: result.data[0][monthKey],
                  data: xsum,
                  goal: eval(goalKey) // ใช้ eval เพื่อดึงค่าจากตัวแปร xgoal1, xgoal2, ...
                });
              } else {
                Tb1.push({
                  name: i.toString(),
                  data_in_Month: result.data[0][monthKey],
                  goal: eval(goalKey) // ใช้ eval เพื่อดึงค่าจากตัวแปร xgoal1, xgoal2, ...
                });
              }
            }
          } else {
            xsum = result.data[0].m1;
            Tb1.push({
              name: "1",
              data_in_Month: result.data[0].m1,
              data: xsum,
              goal: xgoal1
            });

            xsum = xsum + result.data[0].m2;
            Tb1.push({
              name: "2",
              data_in_Month: result.data[0].m2,
              data: xsum,
              goal: xgoal2
            });

            xsum = xsum + result.data[0].m3;
            Tb1.push({
              name: "3",
              data_in_Month: result.data[0].m3,
              data: xsum,
              goal: xgoal3
            });

            xsum = xsum + result.data[0].m4;
            Tb1.push({
              name: "4",
              data_in_Month: result.data[0].m4,
              data: xsum,
              goal: xgoal4
            });

            xsum = xsum + result.data[0].m5;
            Tb1.push({
              name: "5",
              data_in_Month: result.data[0].m5,
              data: xsum,
              goal: xgoal5
            });

            xsum = xsum + result.data[0].m6;
            Tb1.push({
              name: "6",
              data_in_Month: result.data[0].m6,
              data: xsum,
              goal: xgoal6
            });

            xsum = xsum + result.data[0].m7;
            Tb1.push({
              name: "7",
              data_in_Month: result.data[0].m7,
              data: xsum,
              goal: xgoal7
            });

            xsum = xsum + result.data[0].m8;
            Tb1.push({
              name: "8",
              data_in_Month: result.data[0].m8,
              data: xsum,
              goal: xgoal8
            });

            xsum = xsum + result.data[0].m9;
            Tb1.push({
              name: "9",
              data_in_Month: result.data[0].m9,
              data: xsum,
              goal: xgoal9
            });

            xsum = xsum + result.data[0].m10;
            Tb1.push({
              name: "10",
              data_in_Month: result.data[0].m10,
              data: xsum,
              goal: xgoal10
            });

            xsum = xsum + result.data[0].m11;
            Tb1.push({
              name: "11",
              data_in_Month: result.data[0].m11,
              data: xsum,
              goal: xgoal11
            });

            xsum = xsum + result.data[0].m12;
            Tb1.push({
              name: "12",
              data_in_Month: result.data[0].m12,
              data: xsum,
              goal: result.data[0].goal
            });
          }
        }

        if (order == "I3") {
          _dataHigh4(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_PieData = (order, YearValue) => {
    axios
      .post(xURL + "db_Piedata2", {
        order: order,
        year: YearValue,
        year2: parseInt(YearValue) + 543
      })
      .then(result => {
        let Tb1 = [];
        if (result.data[0]) {
          if (order == "I1") {
            Tb1.push({
              name: "Q1",
              value: result.data[0].q1,
              value2: result.data[0].q1Count
            });
            Tb1.push({
              name: "Q2",
              value: result.data[0].q2,
              value2: result.data[0].q2Count
            });
            Tb1.push({
              name: "Q3",
              value: result.data[0].q3,
              value2: result.data[0].q3Count
            });
            Tb1.push({
              name: "Q4",
              value: result.data[0].q4,
              value2: result.data[0].q4Count
            });
            Tb1.push({
              name: "N/A",
              value: result.data[0].na,
              value2: result.data[0].naCount
            });

            _dataPie1(Tb1);
          }
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const [value1, setValue1] = useState(1);

  const onChange1 = e => {
    const newValue = e.target.value;
    setValue1(newValue);

    // หา array ที่จะใช้
    const arr = newValue === 1 ? xYeardh : xYeardh2;

    if (arr.length > 0) {
      const firstYear = arr[0].year; // ได้ค่าชัดเจนแน่นอน
      // เซตค่า slyear เป็น element แรก (index 0)
      form2.setFieldsValue({
        slyear: arr[0].year
      });

      if (newValue === 1) {
        Find_scopus("I1", firstYear);
        Find_scopus("I2", firstYear);
        Find_scopus("I3_1", firstYear);
        Find_scopus("I3", firstYear);
        Find_scopus("I4", firstYear);
        Find_scopus("I5", firstYear);
        Find_scopus("I6", firstYear);

        Find_highData("I3", firstYear);

        Find_PieData("I1", firstYear);
      } else if (newValue === 2) {
        Find_scopus2("I5", firstYear);
      }
    }
  };

  return (
    <React.Fragment>
      <div>
        <h1 className="rise">Internationalized and Impactful Education</h1>
      </div>

      <Form form={form2} initialValues={{ slyear: YearNow }}>
        {/* <Row style={{ marginBottom: "10px" }}>
          <Radio.Group
            value={value1}
            onChange={onChange1}
            options={[
              { value: 1, label: "ปีปฏิทิน" },
              { value: 2, label: "ปีงบประมาณ" }
            ]}
          />
        </Row> */}

        <Row>
          <div>
            <Form.Item label="Year" name="slyear">
              <Select
                style={{ width: 250, marginBottom: "20px" }}
                onChange={value1 === 1 ? handleChange : handleChange2}
              >
                {(value1 === 1 ? xYeardh : xYeardh2).map((i, idx) =>
                  <Option key={idx} value={i.year}>
                    {i.year} ({i.name})
                  </Option>
                )}
              </Select>
            </Form.Item>
          </div>

          {prop.level == 0
            ? <div style={{ marginLeft: "25px" }}>
                <Button
                  type="primary"
                  onClick={() => {
                    form1.resetFields();

                    findGoal();

                    setModalOpen(true);
                  }}
                >
                  Edit Goal
                </Button>
              </div>
            : <div />}
        </Row>
      </Form>

      <Row gutter={3}>
        <Col xs={23} sm={12} md={12} lg={8} xl={8}>
          <Card style={{ height: 160, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  [KR5] ร้อยละผลงานตีพิมพ์ของนักศึกษาที่อยู่ใน Q1 ของฐานข้อมูล
                  Scopus
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <Col span={18}>
                    <p
                      style={{
                        fontWeight: "bold",
                        marginRight: "20px",
                        marginTop: "12px",
                        fontSize: "40px",
                        color: Num_Color1
                      }}
                    >
                      {data_Kr6}
                    </p>
                  </Col>
                  <Col span={3}>
                    <p
                      style={{
                        fontWeight: "bold",
                        // marginRight: "20px",
                        marginLeft: "7px",
                        marginTop: "40px",
                        fontSize: "16px"
                      }}
                    >
                      %
                    </p>
                  </Col>
                </Row>
              </Col>

              <Col span={6} style={{ background: "#1679AB", height: "140px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_Kr6} %
                </p>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6",
                  fontSize: xFontsum
                }}
              >
                ({dataSum_Kr6})
              </p>
            </Row>
          </Card>
        </Col>
        <Col xs={23} sm={12} md={12} lg={8} xl={8}>
          <Card style={{ height: 160, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  [KR6] ร้อยละของนักศึกษาที่เรียนจบตามกำหนดเวลา
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />

                {/* พี่ทรายขอแก้ manual ฟิก 50 % สีเขียว 13/08/2025  */}
                {/* พี่ทรายขอแก้ manual ฟิก 75% 8/9/2025 */}
                {/* พี่ทรายขอแก้ manual ฟิก 22% 5/10/2026 */}
                {YearValue
                  ? <Row>
                      <Col span={18}>
                        <p
                          style={{
                            fontWeight: "bold",
                            marginRight: "20px",
                            marginTop: "12px",
                            fontSize: "40px",
                            color: "red"
                          }}
                        >
                          22
                        </p>
                      </Col>
                      <Col span={3}>
                        <p
                          style={{
                            fontWeight: "bold",
                            // marginRight: "20px",
                            marginLeft: "7px",
                            marginTop: "40px",
                            fontSize: "16px"
                          }}
                        >
                          %
                        </p>
                      </Col>
                    </Row>
                  : <Row>
                      <Col span={18}>
                        <p
                          style={{
                            fontWeight: "bold",
                            marginRight: "20px",
                            marginTop: "12px",
                            fontSize: "40px",
                            color: Num_Color2
                          }}
                        >
                          {data_Kr6_2}
                        </p>
                      </Col>
                      <Col span={3}>
                        <p
                          style={{
                            fontWeight: "bold",
                            // marginRight: "20px",
                            marginLeft: "7px",
                            marginTop: "40px",
                            fontSize: "16px"
                          }}
                        >
                          %
                        </p>
                      </Col>
                    </Row>}
              </Col>

              <Col span={6} style={{ background: "#1679AB", height: "140px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_Kr6_2} %
                </p>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={23} sm={12} md={12} lg={8} xl={8}>
          <Card style={{ height: 160, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  [KR7] การเปิดสอนหลักสูตรใหม่ (จำนวนหลักสูตร)
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />

                {/* พี่ทรายขอแก้ manual ฟิก 50 6/10/2026 */}
                {YearValue
                  ? <Row>
                      <p
                        style={{
                          fontWeight: "bold",
                          marginRight: "20px",
                          marginTop: "12px",
                          fontSize: "40px",
                          color: Num_Color3
                        }}
                      >
                        50
                      </p>
                    </Row>
                  : <Row>
                      <p
                        style={{
                          fontWeight: "bold",
                          marginRight: "20px",
                          marginTop: "12px",
                          fontSize: "40px",
                          color: Num_Color3
                        }}
                      >
                        {data_Kr8}
                      </p>
                    </Row>}
              </Col>

              <Col span={6} style={{ background: "#1679AB", height: "140px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_Kr8}
                </p>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* {YearValue == 2025
          ? <Col xs={23} sm={12} md={12} lg={8} xl={8}>
              <Card style={{ height: 140, marginBottom: "3px" }}>
                <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
                  <Col span={18}>
                    <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                      KR6 %Pub in Q1(STU)
                    </p>
                    <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                    <Row>
                      <Col span={18}>
                        <p
                          style={{
                            fontWeight: "bold",
                            marginRight: "20px",
                            marginTop: "12px",
                            fontSize: "40px",
                            color: Num_Color1
                          }}
                        >
                          {data_Kr6}
                        </p>
                      </Col>
                      <Col span={3}>
                        <p
                          style={{
                            fontWeight: "bold",
                            // marginRight: "20px",
                            marginLeft: "7px",
                            marginTop: "40px",
                            fontSize: "16px"
                          }}
                        >
                          %
                        </p>
                      </Col>
                    </Row>
                  </Col>

                  <Col
                    span={6}
                    style={{ background: "#1679AB", height: "120px" }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        marginTop: "25px"
                      }}
                    >
                      Goal
                    </p>

                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "bold"
                      }}
                    >
                      {goal_Kr6} %
                    </p>
                  </Col>
                </Row>
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginTop: "-50px",
                      color: "#baa6a6"
                    }}
                  >
                    ({dataSum_Kr6})
                  </p>
                </Row>
              </Card>
            </Col>
          : <Col xs={23} sm={12} md={12} lg={8} xl={4}>
              <Card style={{ height: 140, marginBottom: "3px" }}>
                <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
                  <Col span={18}>
                    <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                      KR6 %Pub in Q1(STU)
                    </p>
                    <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                    <Row>
                      <Col span={18}>
                        <p
                          style={{
                            fontWeight: "bold",
                            marginRight: "20px",
                            marginTop: "12px",
                            fontSize: "40px",
                            color: Num_Color1
                          }}
                        >
                          {data_Kr6}
                        </p>
                      </Col>
                      <Col span={3}>
                        <p
                          style={{
                            fontWeight: "bold",
                            // marginRight: "20px",
                            marginLeft: "7px",
                            marginTop: "40px",
                            fontSize: "16px"
                          }}
                        >
                          %
                        </p>
                      </Col>
                    </Row>
                  </Col>

                  <Col
                    span={6}
                    style={{ background: "#1679AB", height: "120px" }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        marginTop: "25px"
                      }}
                    >
                      Goal
                    </p>

                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "bold"
                      }}
                    >
                      {goal_Kr6} %
                    </p>
                  </Col>
                </Row>
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginTop: "-50px",
                      color: "#baa6a6"
                    }}
                  >
                    ({dataSum_Kr6})
                  </p>
                </Row>
              </Card>
            </Col>} */}

        {/* <Col xs={23} sm={12} md={12} lg={8} xl={4}>
          <Card style={{ height: 140, marginBottom: "3px" }}>
            <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
              <Col span={18}>
                <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                  KR7 %Int. STU
                </p>
                <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                <Row>
                  <Col span={18}>
                    <p
                      style={{
                        fontWeight: "bold",
                        marginRight: "20px",
                        marginTop: "12px",
                        fontSize: "40px",
                        color: Num_Color2
                      }}
                    >
                      {dataSum_Kr7}
                    </p>
                  </Col>
                  <Col span={3}>
                    <p
                      style={{
                        fontWeight: "bold",
                        // marginRight: "20px",
                        marginLeft: "7px",
                        marginTop: "40px",
                        fontSize: "16px"
                      }}
                    >
                      %
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span={6} style={{ background: "#1679AB", height: "120px" }}>
                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "25px"
                  }}
                >
                  Goal
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}
                >
                  {goal_Kr7} %
                </p>
              </Col>
            </Row>

            <Row>
              <p
                style={{
                  fontWeight: "bold",
                  marginTop: "-50px",
                  color: "#baa6a6"
                }}
              >
                ({dataSum_Kr7})
              </p>
            </Row>
          </Card>
        </Col> */}

        {/* {YearValue == 2025
          ? <Col xs={23} sm={12} md={12} lg={8} xl={8}>
              <Card style={{ height: 140, marginBottom: "3px" }}>
                <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
                  <Col span={18}>
                    <p style={{ fontWeight: "bold", fontSize: "11px" }}>
                      KR7 %On- time Graduate
                    </p>
                    <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                    <Row>
                      <Col span={18}>
                        6/5/2025 fix ดาต้าปี2025 = 75  6/8
                        {YearValue == 2025
                          ? <p
                              style={{
                                fontWeight: "bold",
                                marginRight: "20px",
                                marginTop: "12px",
                                fontSize: "40px",
                                color: "green"
                              }}
                            >
                              75
                            </p>
                          : <p
                              style={{
                                fontWeight: "bold",
                                marginRight: "20px",
                                marginTop: "12px",
                                fontSize: "40px",
                                color: Num_Color2
                              }}
                            >
                              {data_Kr7}
                            </p>}
                      </Col>
                      <Col span={3}>
                        <p
                          style={{
                            fontWeight: "bold",
                            // marginRight: "20px",
                            marginLeft: "7px",
                            marginTop: "40px",
                            fontSize: "16px"
                          }}
                        >
                          %
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    span={6}
                    style={{ background: "#1679AB", height: "120px" }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        marginTop: "25px"
                      }}
                    >
                      Goal
                    </p>

                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "bold"
                      }}
                    >
                      {goal_Kr7} %
                    </p>
                  </Col>
                </Row>
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginTop: "-50px",
                      color: "#baa6a6"
                    }}
                  >
                    (6/8)
                  </p>
                </Row>
              </Card>
            </Col>
          : <Col xs={23} sm={12} md={12} lg={8} xl={4}>
              <Card style={{ height: 140, marginBottom: "3px" }}>
                <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
                  <Col span={18}>
                    <p style={{ fontWeight: "bold", fontSize: "11px" }}>
                      KR7 %On- time Graduate
                    </p>
                    <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                    <Row>
                      <Col span={18}>
                        6/5/2025 fix ดาต้าปี2025 = 75  6/8
                        {YearValue == 2025
                          ? <p
                              style={{
                                fontWeight: "bold",
                                marginRight: "20px",
                                marginTop: "12px",
                                fontSize: "40px",
                                color: Num_Color2
                              }}
                            >
                              75
                            </p>
                          : <p
                              style={{
                                fontWeight: "bold",
                                marginRight: "20px",
                                marginTop: "12px",
                                fontSize: "40px",
                                color: Num_Color2
                              }}
                            >
                              {data_Kr7}
                            </p>}
                      </Col>
                      <Col span={3}>
                        <p
                          style={{
                            fontWeight: "bold",
                            // marginRight: "20px",
                            marginLeft: "7px",
                            marginTop: "40px",
                            fontSize: "16px"
                          }}
                        >
                          %
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    span={6}
                    style={{ background: "#1679AB", height: "120px" }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        marginTop: "25px"
                      }}
                    >
                      Goal
                    </p>

                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "bold"
                      }}
                    >
                      {goal_Kr7} %
                    </p>
                  </Col>
                </Row>
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginTop: "-50px",
                      color: "#baa6a6"
                    }}
                  >
                    ({dataSum_Kr7})
                  </p>
                </Row>
              </Card>
            </Col>} */}

        {/* {YearValue == 2025
          ? <div />
          : <Col xs={23} sm={12} md={12} lg={8} xl={4}>
              <Card style={{ height: 140, marginBottom: "3px" }}>
                <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
                  <Col span={18}>
                    <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                      No. of STU
                    </p>
                    <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                    <Row>
                      <p
                        style={{
                          fontWeight: "bold",
                          marginRight: "20px",
                          marginTop: "12px",
                          fontSize: "40px",
                          color: Num_Color4
                        }}
                      >
                        {data_NoSTU}
                      </p>
                    </Row>
                  </Col>
                  <Col
                    span={6}
                    style={{ background: "#1679AB", height: "120px" }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        marginTop: "25px"
                      }}
                    >
                      Goal
                    </p>

                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "bold"
                      }}
                    >
                      {goal_NoSTU}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginTop: "-50px",
                      color: "#baa6a6"
                    }}
                  >
                    ({dataSum_NoSTU})
                  </p>
                </Row>
              </Card>
            </Col>} */}

        {/* {YearValue == 2025
          ? <div />
          : <Col xs={23} sm={12} md={12} lg={8} xl={4}>
              <Card style={{ height: 140, marginBottom: "3px" }}>
                <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
                  <Col span={18}>
                    <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                      Pub in SCOPUS(STU)
                    </p>
                    <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                    <Row>
                      <Col span={18}>
                        <p
                          style={{
                            fontWeight: "bold",
                            marginRight: "20px",
                            marginTop: "12px",
                            fontSize: "40px",
                            color: Num_Color5
                          }}
                        >
                          {data_PubSTU}
                        </p>
                      </Col>
                      <Col span={3}>
                        <p
                          style={{
                            fontWeight: "bold",
                            // marginRight: "20px",
                            marginLeft: "7px",
                            marginTop: "40px",
                            fontSize: "16px"
                          }}
                        >
                          %
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    span={6}
                    style={{ background: "#1679AB", height: "120px" }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        marginTop: "25px"
                      }}
                    >
                      Goal
                    </p>

                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "bold"
                      }}
                    >
                      {goal_PubSTU}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginTop: "-50px",
                      color: "#baa6a6"
                    }}
                  >
                    ({dataSum_PubSTU})
                  </p>
                </Row>
              </Card>
            </Col>} */}

        {/* {YearValue == 2025
          ? <div />
          : <Col xs={23} sm={12} md={12} lg={8} xl={4}>
              <Card style={{ height: 140, marginBottom: "3px" }}>
                <Row style={{ marginRight: "-15px", marginTop: "-15px" }}>
                  <Col span={18}>
                    <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                      Total Graduate STU
                    </p>
                    <hr style={{ marginRight: "10px", marginTop: "-5px" }} />
                    <Row>
                      <p
                        style={{
                          fontWeight: "bold",
                          marginRight: "20px",
                          marginTop: "12px",
                          fontSize: "40px",
                          color: Num_Color6
                        }}
                      >
                        {data_GradSTU}
                      </p>
                    </Row>
                  </Col>
                  <Col
                    span={6}
                    style={{ background: "#1679AB", height: "120px" }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        marginTop: "25px"
                      }}
                    >
                      Goal
                    </p>

                    <p
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "bold"
                      }}
                    >
                      {goal_GradSTU}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginTop: "-50px",
                      color: "#baa6a6"
                    }}
                  >
                    ({dataSum_GradSTU})
                  </p>
                </Row>
              </Card>
            </Col>} */}
      </Row>

      <div style={{ height: "10px" }} />

      <Row gutter={16}>
        {/* <Col xs={23} sm={23} md={12} lg={12} xl={12}>
          <Card style={{ height: 280 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              No. of STU
            </p>
            <Mixchart />
          </Card>
        </Col> */}

        <Col xs={23} sm={23} md={12} lg={12} xl={12}>
          <Card style={{ height: 300 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              จำนวนผลงานตีพิมพ์ใน SCOPUS ของนักศึกษา
            </p>
            <Hightchart2 dataHigh={dataHigh4} order={1} />
          </Card>
        </Col>
        <Col xs={23} sm={23} md={12} lg={12} xl={12}>
          <Card style={{ height: 300 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              ร้อยละผลงานตีพิมพ์ของนักศึกษาที่อยู่ใน Q1 ของฐานข้อมูล Scopus
            </p>

            <Piechart2 dataPie={dataPie1} />
          </Card>
        </Col>
      </Row>

      {/* <Row gutter={16}>
        <Col xs={23} sm={23} md={12} lg={8} xl={8}>
          <Card style={{ height: 280 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              KR7 %On- time Graduate
            </p>
            <Hightchart2 dataHigh={dataHigh3} order={1} />
          </Card>
        </Col>
        <Col xs={23} sm={23} md={12} lg={8} xl={8}>
          <Card style={{ height: 280 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              KR8 New Program
            </p>
            <Hightchart2 dataHigh={dataHigh2} order={1} />
          </Card>
        </Col>
        <Col xs={23} sm={23} md={12} lg={8} xl={8}>
          <Card style={{ height: 280 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              No. of STU
            </p>
            <Hightchart2 dataHigh={dataHigh6} order={1} />
          </Card>
        </Col>
      </Row> */}

      {/* <div style={{ height: "10px" }} /> */}

      {/* <Row gutter={16}>
        <Col xs={23} sm={23} md={12} lg={12} xl={12}>
          <Card style={{ height: 280 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              Pub in SCOPUS(STU)
            </p>
            <Hightchart2 dataHigh={dataHigh4} order={1} />
          </Card>
        </Col>
        <Col xs={23} sm={23} md={12} lg={12} xl={12}>
          <Card style={{ height: 280 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              Total Graduate STU
            </p>
            <Hightchart2 dataHigh={dataHigh4} order={1} />
          </Card>
        </Col>
      </Row> */}

      {/* <div style={{ height: "10px" }} />

      <Row gutter={16}>
        <Col xs={23} sm={23} md={24} lg={24} xl={24}>
          <Card style={{ height: 320 }}>
            <p
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold"
              }}
            >
              %Quarties(STU)
            </p>

            <Piechart2 dataPie={dataPie1} />
          </Card>
        </Col>
      </Row> */}

      <div style={{ height: "180px" }} />

      <Modal
        title="Edit Goal"
        centered
        visible={modalOpen}
        onOk={() => setModalOpen(false)}
        onCancel={() => setModalOpen(false)}
        footer={null}
        width={1000}
      >
        <p style={{ fontWeight: "bold", fontSize: "18px" }}>
          Year {YearValue}
        </p>
        <hr className="style-two" style={{ marginBottom: "20px" }} />

        <Form form={form1} initialValues={{}}>
          <Row>
            <Col span={6}>
              <p className="t-goal">
                [KR5] ร้อยละผลงานตีพิมพ์ของนักศึกษาที่อยู่ใน Q1 ของฐานข้อมูล
                Scopus
              </p>
            </Col>
            <Col span={3}>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr6">
                  <InputNumber
                    autoFocus
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col>
              <p> %</p>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <p className="t-goal">
                [KR6] ร้อยละของนักศึกษาที่เรียนจบตามกำหนดเวลา
              </p>
            </Col>
            <Col span={3}>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr6_1">
                  <InputNumber
                    autoFocus
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col>
              <p> %</p>
            </Col>
          </Row>

          <Row>
            <Col span={6}>
              <p className="t-goal">
                [KR7] การเปิดสอนหลักสูตรใหม่ (จำนวนหลักสูตร)
              </p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr8">
                  <InputNumber
                    min={0}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          {/* <Row>
            <Col span={4}>
              <p className="t-goal">KR7 %Int. STU</p>
            </Col>
            <Col span={3}>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr7">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col>
              <p> %</p>
            </Col>
          </Row> */}
          {/* <Row>
            <Col span={4}>
              <p className="t-goal">KR7 %On- time Graduate</p>
            </Col>
            <Col span={3}>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipKr7">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col>
              <p> %</p>
            </Col>
          </Row> */}

          {/* <Row>
            <Col span={4}>
              <p className="t-goal">No. of STU</p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipStu">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <p className="t-goal">Pub in SCOPUS(STU)</p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipPubStu">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <p className="t-goal">Total Graduate STU</p>
            </Col>
            <Col>
              <div style={{ marginTop: "-5px" }}>
                <Form.Item label="" name="ipGStu">
                  <InputNumber
                    min={1}
                    max={1000}
                    maxLength="4"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row> */}
        </Form>

        <hr className="style-two" style={{ marginBottom: "20px" }} />

        <Row justify="center">
          <Space>
            <Button
              type="primary"
              onClick={() => {
                bSaveclick();
              }}
            >
              <SaveOutlined /> Save
            </Button>

            <Button
              type="danger"
              onClick={() => {
                bClearclick();
              }}
            >
              <ClearOutlined /> Reset
            </Button>
          </Space>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default Dashboard_i;
